import "./style.css";

export default class Footer {
  static selector = ".s-footer";

  constructor(block) {
    this.block = block;
    this.$signIn = this.block.querySelector("#sign-in");
    this.addListeners();
  }

  onSignInClick(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.__$user && window.__$user.click();
  }

  addListeners() {
    if (this.$signIn) {
      this.$signIn.addEventListener("click", this.onSignInClick.bind(this));
    }
  }
}
